import React from 'react';
import wb0 from '../img/Detail/tears_detail.jpg';
import './Detail.css';
const TearsDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default TearsDetail;